import React from 'react';
/*
import {
  ht,
  cr,
  a,
  ls,
  LblC,
  TblC,
  TextC,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as LblC from "./_cccLblC";
import * as TblC from "./_ccmTblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i1zz: ht.dz,
  }
}) => {

  const _frcUdt = ls.frcUdt();

  const _hdrs = [
    {
      cellCs: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用日',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '部屋',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用時間帯',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '施設',
              }
            })
          ]
        },
      ]
    },
  ];

  const _bdys = [
    {
      cellCs: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: pz.cz.i1zz.i1zrz?.i1zrd3100s
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: pz.cz.i1zz.i1zrz?.i1zra1100s
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: pz.cz.i1zz.i1zrz?.i1zra1200s
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: pz.cz.i1zz._31rz?._pfx
              }
            })
          ]
        },
      ]
    },
  ];

  return (
    cr.c(LblC.N, {
      key: 'Iccv23b3a',
      abtType: 'bandAltCmnz',
      boxStlz: a('bc/rd5 bw/2 dw/100 mt/3 mb/5'),
      lblCz: {
        boxStlz: a(`fd/rcc`),
        textz: {
          pfx: 
            pz.sPz.crt.ctt == 'r' ?
              '仮押中の部屋・日時'
            : pz.sPz.crt.ctt == 'e' ?
              'エントリーする部屋・日時'
            : '',
        }
      },
      cttCz: {
        oClds: [
          cr.c(TblC.N, {
            key: -20,
            abtType: 'nmlz',
            srlCz: {
              srlStlz: {
                otrz: a('dw/f'),
              },
            },
            hdrCz: {
              abtType: 'nolineCmnz',
              lineCs: _hdrs,
            },
            bdyCz: {
              abtType: 'nolineCmnz',
              lineCs: _bdys,
            }
          }),
        ]
      }
    })
  );
};
